import { doesIdentityRequireRefresh, isIdentityExpired, memoizeIdentityProvider, } from "@smithy/core";
import { HttpApiKeyAuthLocation, } from "@smithy/types";
import { getSmithyContext } from "@smithy/util-middleware";
export const defaultSimulationServiceHttpAuthSchemeParametersProvider = async (config, context, input) => {
    return {
        operation: getSmithyContext(context).operation,
    };
};
function createSmithyApiHttpApiKeyAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#httpApiKeyAuth",
        signingProperties: {
            name: "Authorization",
            in: HttpApiKeyAuthLocation.HEADER,
            scheme: undefined,
        },
    };
}
;
export const defaultSimulationServiceHttpAuthSchemeProvider = (authParameters) => {
    const options = [];
    switch (authParameters.operation) {
        default:
            {
                options.push(createSmithyApiHttpApiKeyAuthHttpAuthOption(authParameters));
            }
            ;
    }
    ;
    return options;
};
export const resolveHttpAuthSchemeConfig = (config) => {
    const apiKey = memoizeIdentityProvider(config.apiKey, isIdentityExpired, doesIdentityRequireRefresh);
    return {
        ...config,
        apiKey,
    };
};
